import {sbCreateGroupChannelListQuery} from '../../account/app/sendbirdActions' 
/**
 * @returns string
 */
export default function getUnreadMessagesCount() {
    return new Promise((resolve) => {
        let count = 0
        let listQuery = sbCreateGroupChannelListQuery()

        if (listQuery.hasNext) {
            listQuery.next((groupChannels, error) => {
                if (error) {
                    reject(error)
                } else {
                    groupChannels.forEach(channel => {
                    count += channel.unreadMessageCount
                    })
                    resolve(count)
                }
            })
        }
    })
}

